export const EstadoVistaColaboradorFormulario = {
    PENDIENTE: "PENDIENTE",
    PENDIENTE_APROBACION: "PENDIENTE_APROBACION",
    VISUALIZADO: "VISUALIZADO",
    FIRMADO: "FIRMADO",
    RECHAZADO: "RECHAZADO"
}